import { render, staticRenderFns } from "./editins.vue?vue&type=template&id=c27dd278"
import script from "./editins.vue?vue&type=script&lang=js"
export * from "./editins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports